import {register} from '@shopify/theme-sections';

const selectors = {
  slider: '[data-slider]',
  slide: '[data-slide]',
};

export default register('business-reviews', {
  onLoad() {
    const container = this.container;
    const elem = container.querySelector(selectors.slider);

    if (!elem) return;

    return new Flickity(elem, {
      freeScroll: false,
      prevNextButtons: true,
      pageDots: false,
      cellAlign: 'center',
      contain: true,
      cellSelector: selectors.slide,
    });
  },
});
